<template>
  <b-col cols="12" md="12" lg="6" style="min-height: 200px">
    <h5>
      {{ $t('cascade_access.provided_accesses_on_other_resources') }}
    </h5>
    <b-button class="my-2" variant="secondary"
              @click="onAppliedAccessCreate">
      {{ $t('cascade_access.provide_access') }}
    </b-button>
    <loader v-if="appliedLoading"/>
    <v-client-table
        v-if="appliedCascadeAccessesTableData && !appliedLoading"
        :data="appliedCascadeAccessesTableData"
        :columns="appliedTableConfig.columns"
        :options="appliedTableConfig.options">
      <template slot="active" slot-scope="props">
        <column-check :row="props.row" column="active"/>
      </template>
      <template slot="actions" slot-scope="props">
        <column-action
            :show-edit-button="true"
            @edit="onAppliedAccessUpdate(props.row)"
            :deleteUrl="`partners/${partnerId}/cascade-access/applied/${props.row.id}`"
            @deleteItems="getAppliedCascadeAccesses"/>
      </template>
    </v-client-table>
  </b-col>
</template>

<script>
import i18n from "@/utils/i18n";
import {get} from "lodash";

export default {
  name: "AppliedCascadeAccessView",
  components: {},
  props: {
    partnerId: {
      type: Number,
      required: true
    },
    resourceKey: {
      type: String,
      required: true
    },
    cascadeAccess: {
      type: Object,
      required: true
    },
    partnerResources: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      usedResources: [],
      appliedCascadeAccessesTableData: [],
      appliedLoading: false,
      loading: false,
      appliedTableConfig: {
        columns: ['resource', 'type', "access", "active", "actions"],
        options: {
          skin: 'table-p-1',
          headings: {
            active: i18n.t('form.active'),
            actions: "",
          },
          filterable: false
        }
      }
    }
  },
  created() {
    this.getAppliedCascadeAccesses();
  },
  mounted() {
    this.$bus.$on(`reloadAppliedCascadeAccesses-${this.cascadeAccess.id}`,
        () => {
          this.getAppliedCascadeAccesses();
        });
  },
  destroyed() {
    this.$bus.$off(`reloadAppliedCascadeAccesses-${this.cascadeAccess.id}`);
  },
  methods: {
    async getAppliedCascadeAccesses() {
      this.appliedLoading = true
      this.getData(`partners/${this.partnerId}/cascade-access/${this.cascadeAccess.id}/applied`)
          .then(({data}) => {
            if (Array.isArray(data.items)) {
              this.appliedCascadeAccessesTableData = data.items.map((item) => {
                return {
                  id: item.id,
                  resource: item.resource.title,
                  type: this.getAppliedCascadeAccessTypeTitle(item),
                  access: this.getAppliedCascadeAccessSource(item),
                  active: item.active,
                  rawData: item
                }
              })

              const usedResources = data.items.map((item) => item.resource.key);
              usedResources.push(this.resourceKey);
              this.usedResources = usedResources;
            }
          })
          .catch(error => {
            if (error && error.response) {
              this.$noty.error(error.response.data.error_description);
            }
          })
          .finally(() => {
            this.appliedLoading = false;
          })
    },

    onAppliedAccessUpdate(appliedAccessItem) {
      this.$bus.$emit('openUpdateAppliedCascadeAccess', {
        usedResources: this.usedResources,
        appliedAccessItem: appliedAccessItem
      }, this.getAppliedCascadeAccessType())
    },

    onAppliedAccessCreate() {
      this.$bus.$emit('openCreateAppliedCascadeAccess', {
        usedResources: this.usedResources
      }, this.getAppliedCascadeAccessType())
    },

    getAppliedCascadeAccessTypeTitle(item) {
      if (item.plan_id) return i18n.t('cascade_access.type_plan')
      if (item.ti_event_id) return i18n.t('cascade_access.type_event')
      if (item.content_id) return i18n.t('cascade_access.type_content')
    },

    getAppliedCascadeAccessSource(item) {
      if (item.plan_id) return item.plan.title;
      if (item.ti_event_id) return item.ti_event.title;
      if (item.content_id) return item.content.title;
    },

    getAppliedCascadeAccessType() {
      if (get(this.cascadeAccess, "subscription", null)) {
        return "type_plan";
      }
      if (get(this.cascadeAccess, "ti_event_ticket", null)) {
        return "type_event";
      }
      if (get(this.cascadeAccess, "content", null)) {
        return "type_content";
      }
      return null;
    },
  }
}
</script>

